<template>
  <div v-if="!readOnly && !field.readOnly">
    <v-subheader v-if="field.label" class="pl-0">
      {{ field.label }}
      <strong v-if="field.quantity && field.quantity.show">
        : ({{ fieldValue || 0 }}) {{ field.quantity.label }}
      </strong>
    </v-subheader>
    <v-slider ref="inputRef"
              v-model="fieldValue"
              :required="field.required"
              :thumb-label="field.thumbLabel"
              :max="field.max"
              :min="field.min"
              :step="field.step"
              :inverse-label="field.inverseLabel"
              :height="field.height"
              :always-dirty="field.alwaysDirty"
              :hint="field.hint"
              :persistent-hint="true"
              :rules="validationRules"
              @input="fieldChanged"
              @change="fieldChanged" />
  </div>
  <div v-else :class="{'reg-information': !small, 'reg-information-small': small}">
    <label>{{ field.label }}</label>
    <p>{{ fieldValue }}</p>
  </div>
</template>

<script>
import { defineComponent, toRef } from 'vue'
import { useDynamicField } from '../composables/useDynamicField'

export default defineComponent({
  name: 'DynamicSlider',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const {
      fieldValue,
      validationRules,
      inputRef,
      fieldChanged,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: 0,
      emit
    })

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      validationRules,
      inputRef,
      fieldChanged
    }
  }
})
</script>

<style lang="scss">
.input-group.input-group--slider {
  padding-right: 0;
}
</style>